module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"Edit link tree","delete":"Delete link tree","titleRow":"Table number: \\"{0}\\"","previewQRs":"See QR Codes.","downloadQRs":"Download QR Codes."},"es":{"edit":"Editar arbol de links","delete":"Eliminar arbol de links","titleRow":"Mesa numero: \\"{0}\\"","previewQRs":"Visualizar códigos QR.","downloadQRs":"Descargar códigos QR."}}')
  delete Component.options._Ctor
}
